export const TIMER_COOKIE_NAME = 'new-worlds-launch-modal-timer';
export const STORAGE_KEY = 'launchModalShown';
export enum DISPLAY_CODES {
    SHOW_AGAIN_IN_7_DAYS = 1,
    NEVER_AGAIN = 2
}
export const DELAY_IN_DAYS = 7;
